import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
      padding: theme.spacing(2.5),
      backgroundColor: COLORS.neutral.white,
      border: theme.shape.borderGray60,
      borderRadius: theme.shape.borderRadius,
    },
    metric: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 500,
      color: theme.palette.text.secondary,
      marginBottom: theme.spacing(1),
    },
    value: {
      fontSize: theme.typography.pxToRem(28),
      fontWeight: 700,
      color: theme.palette.text.primary,
      lineHeight: 1.2,
    },
    definition: {
      fontSize: theme.typography.pxToRem(11),
      color: theme.palette.text.disabled,
      marginTop: theme.spacing(1),
    },
  }),
  { name: 'KpiCard' }
);
